'use client'

import React from 'react'

import {
  AlternativeAppContext,
  IAlternativeAppContext,
} from './AlternativeAppContext'

export const AlternativeAppContextProvider = ({
  children,
  isAlternative,
}: {
  children: React.ReactNode
  isAlternative: boolean
}) => {
  const context: IAlternativeAppContext = {
    isAlternative,
  }

  return (
    <AlternativeAppContext.Provider value={context}>
      {children}
    </AlternativeAppContext.Provider>
  )
}
